// eslint-disable-next-line import/prefer-default-export, no-shadow
export enum PreferencesActionTypes {
  SetAppLanguage = 'SetAppLanguage',
}
